/* VORES EGET filtersystem — uafhængigt af Shopifys storefront-filtre.
 *
 * Hvorfor: Shopifys filtre kan KUN oprettes ved at klikke i Search & Discovery-appen, der
 * findes ingen API. Verificeret på live: `?filter.p.m.endorse.hudtype=Tør`, `?filter.p.vendor=…`
 * og `?filter.p.tag=…` ændrede ingenting (253 produkter før og efter), kun prisfilteret virkede
 * fordi det er slået til som standard. Vi ejer selv hele datalaget, så vi filtrerer selv.
 *
 * Det giver samtidig tre ting Shopifys egen løsning ikke kan, og som ingen af de danske
 * konkurrenter har samlet: antal der opdateres LIVE når man kombinerer filtre, multivalg
 * inden for en gruppe (Tør ELLER Fedtet), og ingen sideindlæsning.
 *
 * Data: assets/catalog-facets.json (75 KB gzip, bygget af _build-facets.mjs).
 * Første visning er stadig server-renderet af Liquid — der røres intet før brugeren
 * faktisk filtrerer, så første paint og SEO er uændret.
 */
(function () {
  "use strict";

  var CFG = window.EndorseSearch || {};
  var PER_PAGE = 26;   // skal matche `paginate collection.products by 26` i sections/collection.liquid

  /* Sidestørrelsen på FILTREREDE resultater sættes her i JS, og der er den ikke
     bundet til serverens tal: vi ejer både vinduet og pagineringen. Vi låner
     derfor et par produkter frem fra næste side indtil antallet plus et
     kampagnefelts areal går op i kolonneantallet — ellers står der tomme celler
     i sidste række, præcis som der gjorde på kategorisiderne med 25.
     Resultatet er stabilt for en given bredde, så sidegrænserne ikke skrider. */
  function colsOf(grid) {
    var cs = window.getComputedStyle(grid);
    if (cs.display.indexOf("grid") === -1) return 1;
    return cs.gridTemplateColumns.split(" ").filter(Boolean).length;
  }

  /* FYLD-TILSTAND (Mikkel, 2026-09-08: "alle 6 rækker i gitteret skal stadig være
     fyldt … den burde bare fylde op fra næste side af"). Puljen af kampagnefelter er
     TOM når HQ ingen færdige kampagner har (rev 295), og så lukker intet felt
     gitteret: 26 varer på fem kolonner er fire tomme celler i sidste række, og
     tomme celler er huller. Uden felter er sidestørrelsen derfor det mindste tal
     fra 26 der går op i kolonneantallet — 30 på fem, 28 på fire, 27 på tre, 26 på
     to — og de manglende varer lånes frem fra de næste sider. Findes der felter,
     gælder den gamle regel: 26 + feltets areal lukker gitteret. `__campPool`
     sættes af campaign-tiles.liquid; er den ikke afgjort endnu (koldt feed), er
     svaret "ikke tom", og endorse:felter-hændelsen tegner om når den lander. */
  /* "Uden felter" = puljen er tom ELLER kan ikke lukke en side på `cards` kort i
     denne bredde. Ét enkelt 2x1 er areal 2, og 26 + 2 går ikke op i fem kolonner,
     så på desktop ville der stå hverken felt eller fuld række — samme hul som en
     tom pulje (Mikkel, 2026-09-08: "så snart vi tilføjer en hvilken som helst
     kampagnestørrelse …"). Felt-motorens egen combos() afgør det (kanLukke), så de
     to kan ikke blive uenige. Ikke afgjort endnu (koldt feed) = "med felter", og
     endorse:felter-hændelsen tegner om når puljen lander. */
  function udenFelter(grid, cards) {
    var p = grid.__campPool;
    var E = window.EndorseCampaigns;
    if (!E || !p) return false;
    if (!p.length) return true;
    if (!E.kanLukke) return false;
    var cols = colsOf(grid);
    if (cols < 2) return false;
    return !E.kanLukke(p, cards || PER_PAGE, cols);
  }
  function fyldSize(cols) {
    var n = PER_PAGE;
    while (n % cols) n++;
    return n;
  }
  /* Sidestørrelsen på FILTREREDE (JS-tegnede) sider: den mindste fra 26 som
     PULJEN kan lukke — ét 2x1 lukker 28 på fem kolonner, et 2x2 lukker 26. Kan
     puljen ikke lukke noget (eller er tom), fyldes rækken med varer i stedet. */
  function pageSizeFor(grid) {
    var E = window.EndorseCampaigns;
    if (!E || !E.pageSize) return PER_PAGE;
    var cols = colsOf(grid);
    if (cols < 2) return PER_PAGE;
    var p = grid.__campPool;
    if (!p) return E.pageSize(PER_PAGE, cols);            // puljen er ikke afgjort endnu
    if (!p.length || !E.kanLukke) return p.length ? E.pageSize(PER_PAGE, cols) : fyldSize(cols);
    for (var n = PER_PAGE; n <= PER_PAGE + cols; n++) {
      if (E.kanLukke(p, n, cols)) return n;
    }
    return fyldSize(cols);
  }

  /* ---------------------------------------------------------------- data */
  var dataPromise = null;
  function loadFacets() {
    if (dataPromise) return dataPromise;
    if (!CFG.facets) return (dataPromise = Promise.reject(new Error("no facets")));
    // Overlayet hentes SIDELØBENDE med den statiske fil, ikke efter: det er en
    // ekstern kilde og må ikke lægge sin latens oven i vores egen.
    var ovPromise = window.EndorseOverlay
      ? window.EndorseOverlay.load()
      : Promise.resolve(null);

    /* PRØVET OG RULLET TILBAGE 2026-09-09: priority: "low" paa kategorisider.
     *
     * Ideen var god paa papiret. Filen er 66 kB, blev hentet med browserens
     * standard for et fetch (altsaa HIGH), og landede 5373 -> 6660 ms mens LCP laa
     * paa 8520 — den konkurrerede altsaa direkte med det element siden maales paa,
     * og siden er baandbredde-bundet. Sikkerheden var ogsaa maalt: nul layout-skift
     * over 0,01 paa kategorisiden over otte koersler, fordi gridIsServer forhindrer
     * at serverens gitter rives ned ved foerste koersel.
     *
     * MAALINGEN AFVISTE DEN (rev 309 -> 310, medianer af fem koersler, otte ruter):
     *   LCP-TTFB  bedre 4 af 8, samlet -1 %   altsaa ingen effekt
     *   TBT       bedre 1 af 8, samlet +8 %   altsaa VAERRE
     *   FCP-TTFB  bedre 3 af 8, samlet +4 %
     *
     * En plausibel mekanisme: naar facetterne lander senere, falder afkodningen af
     * de 1017 raekker til objekter (nedenfor) sammen med billedafkodning i stedet
     * for at ligge i en rolig periode. Det kan ogsaa vaere omgivelses-stoej fra
     * maskinen. Uanset hvad: ingen gevinst, maalbar bagside, rullet tilbage.
     *
     * Proev den ikke igen uden at maale TBT, ikke kun LCP. */

    dataPromise = Promise.all([
      fetch(CFG.facets).then(function (r) { return r.json(); }),
      ovPromise,
    ]).then(function (par) {
      var d = par[0], ov = par[1];
      // Decode into objects once; everything downstream reads plain properties.
      d.produkter = d.p.map(function (row) {
        var attrs = {};
        for (var i = 0; i < row[10].length; i++) {
          var dim = d.dims[row[10][i][0]];
          attrs[dim.k] = row[10][i][1].map(function (vi) { return dim.vals[vi]; });
        }
        return {
          handle: row[0], title: row[1], brand: row[2],
          img: row[3] ? d.imgPrefix + row[3] : "",
          price: row[4], size: row[5], variantId: row[6], avail: !!row[7],
          cat: d.cats[row[8]], sub: d.subs[row[9]], attrs: attrs, compareAt: row[11] || 0,
          bundle: !!row[12], parts: row[13] || null,
          // Sekundære hylder (kolonne 14, _build-facets.mjs): [[cat, sub], ...]
          also: row[14] ? row[14].map(function (a) { return [d.cats[a[0]], d.subs[a[1]]]; }) : null,
          // Popularitet 0-1000 (kolonne 15, _byg-popularitet.mjs). 0 = ingen data.
          pop: row[15] || 0,
          // Kladde da filen blev bygget (kolonne 16). Vises kun naar feedet bekraefter at
          // varen er aktiv; reglen bor i EndorseOverlay.skjulKladder.
          kladde: !!row[16],
        };
      });
      // BUNDLE-OVERLAYET. Nye bundles står ikke i den statiske facet-fil før
      // nogen har kørt _build-facets.mjs og pushet temaet; uden det her
      // forsvinder de ved første filterklik (målt live: 5 kort blev til 0).
      // Indflettningen sker PRÆCIS her, fordi det er det eneste sted hvor hele
      // universet findes som ét array — alt nedstrøms læser kun d.produkter, så
      // denne ene linje retter facet-tællinger, prisslider, sortering,
      // paginering og byHandle på én gang. Reglen selv står i endorse-overlay.js.
      // Uden overlay-scriptet kan intet bekraefte en kladde, saa de skjules alle.
      if (!ov) d.produkter = d.produkter.filter(function (x) { return !x.kladde; });
      if (ov) {
        d.produkter = window.EndorseOverlay.merge(d.produkter, ov);
        // Mærke-kanoniseringen af ?maerke= slår op i d.brands, så et delt link
        // til en bundles mærke skal kunne findes der.
        for (var b = 0; b < ov.produkter.length; b++) {
          if (ov.produkter[b].brand && d.brands.indexOf(ov.produkter[b].brand) === -1) {
            d.brands.push(ov.produkter[b].brand);
          }
        }
      }

      /* ET TOMT parts-ARRAY ER IKKE EN BUNDLE (2026-09-14).
         `p.parts` blev brugt som sandhedsvaerdi ("er det en bundle?"), men et
         tomt array er truthy i JavaScript. Overlayet fra /api/bundles/live
         sender `parts: []` paa ALLE sine varer — ogsaa de helt almindelige der
         bare mangler i den statiske facet-fil — saa 21 varer fik klassen
         product-card--bundle i gitteret. Og fordi
         `.product-card--bundle .product-card__content { display: none }`,
         forsvandt varens NAVN og pris-stribe, og bundle-layoutets samlede pris
         blev tegnet midt under et almindeligt produktfoto. Meldt som "der er en
         centreret pris, men ikke navn — den ligner slet ikke de andre".

         Normaliseringen ligger HER og ikke ved hvert opslag, fordi det er det
         eneste sted hvor baade de statiske raekker og overlayet er flettet
         sammen til ét array. Samme regel som Liquid bruger i
         snippets/product-card.liquid: `bundle_parts != blank AND size > 0`. */
      d.byHandle = {};
      d.produkter.forEach(function (p) {
        if (p.parts && !p.parts.length) p.parts = null;
        d.byHandle[p.handle] = p;
      });
      return d;
    });
    return dataPromise;
  }

  /* --------------------------------------------------------------- utils */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function money(cents) {
    if (!(cents > 0)) return "";
    try {
      return new Intl.NumberFormat("da-DK", { style: "currency", currency: "DKK" }).format(cents / 100);
    } catch (e) { return Math.round(cents / 100) + " kr"; }
  }
  var MAERKE = "maerke", PRIS = "pris", LAGER = "lager", LIKED = "liked", SORT = "sort";
  /* TILBUD er et filter i kategorien, ikke en anden side (Mikkel, 2026-09-01).
     Tilbudscirklen stod mellem hudplejes ti hylder, men pegede på den butiksbrede
     /collections/tilbud. Den er sin egen collection uden metafeltet
     endorse.subcategories, så hylderækken blev slet ikke tegnet dér: ét klik på en
     cirkel i rækken fjernede hele rækken. Det skete uanset om der VAR tilbud;
     tomheden gjorde det bare tydeligt, fordi så var der hverken hylder eller varer
     tilbage på skærmen. Nu bliver man i kategorien og ser dens nedsatte varer. */
  var TILBUD = "tilbud";

  /* ------------------------------------------------------------ tilstand */
  // URL is the single source of truth, so a filtered view is shareable and the back
  // button behaves. One readable param per dimension: ?hudtype=Tør,Fedtet&maerke=Aveda
  // Params that are NOT filters. `q` is the big one: it carries the search term, and
  // treating it as a dimension filtered every product away (nothing has an attribute
  // called "q"), which is what made /search?q=tør+hud render zero results.
  // `camp` hører med: campaign-tiles.liquid bruger ?camp=<id> til at tvinge ét
  // bestemt kampagnefelt frem ved gennemsyn. Uden den her ville den blive læst
  // som en filterdimension der ikke findes, og gitteret ville vise nul produkter.
  var RESERVED = ["q", "page", "view", "type", "options", "camp", "campsize"];

  function readState() {
    var q = new URLSearchParams(location.search);
    // `page` læses eksplicit og bliver i URL'en sammen med filtrene. Det var her
    // filteret forsvandt: serverens pagineringslinks bærer kun ?page=N, så et klik
    // forlod den filtrerede tilstand. Nu ejer vi pagineringen når der er filtreret.
    var st = { dims: {}, brands: [], price: null, stock: false, liked: false, tilbud: false,
               sort: q.get(SORT) || "", q: q.get("q") || "",
               page: Math.max(1, parseInt(q.get("page"), 10) || 1) };
    q.forEach(function (val, key) {
      if (key === SORT || RESERVED.indexOf(key) > -1 || key.indexOf("filter.") === 0) return;
      if (key === MAERKE) { st.brands = val.split(",").filter(Boolean); return; }
      if (key === LAGER) { st.stock = val === "1"; return; }
      // Favoritter (ønskelisten). Skal interceptes HER ligesom lager — ellers
      // falder ?liked=1 igennem til st.dims og bliver en fantom-facet der
      // filtrerer hele kataloget væk.
      if (key === LIKED) { st.liked = val === "1"; return; }
      // Samme grund som lager og favoritter: uden den her ville ?tilbud=1 falde
      // igennem til st.dims og blive en facet der ikke findes, og så filtrere
      // hele kataloget væk i stedet for kun de varer der ikke er nedsat.
      if (key === TILBUD) { st.tilbud = val === "1"; return; }
      if (key === PRIS) {
        var m = val.split("-");
        if (m.length === 2) st.price = [parseInt(m[0], 10) || 0, parseInt(m[1], 10) || 0];
        return;
      }
      st.dims[key] = val.split(",").filter(Boolean);
    });
    return st;
  }
  function writeState(st, replace) {
    var q = new URLSearchParams();
    if (st.q) q.set("q", st.q);   // never lose the search term when a filter is applied
    Object.keys(st.dims).forEach(function (k) { if (st.dims[k].length) q.set(k, st.dims[k].join(",")); });
    if (st.brands.length) q.set(MAERKE, st.brands.join(","));
    if (st.stock) q.set(LAGER, "1");
    if (st.liked) q.set(LIKED, "1");
    if (st.tilbud) q.set(TILBUD, "1");
    if (st.price) q.set(PRIS, st.price[0] + "-" + st.price[1]);
    if (st.sort) q.set(SORT, st.sort);
    if (st.page > 1) q.set("page", st.page);
    var url = location.pathname + (q.toString() ? "?" + q.toString() : "");
    history[replace ? "replaceState" : "pushState"]({}, "", url);
  }
  /* Samme query-streng som writeState, men til en ANDEN sti: bruges naar et produkttype-valg
     flytter kunden til typesidens egen URL eller tilbage til kategorien. Alt andet (maerke, pris,
     lager, sortering) skal overleve skiftet, ellers foeles det som at starte forfra. */
  function urlTil(sti, st, dim, vaerdier) {
    var q = new URLSearchParams();
    if (st.q) q.set("q", st.q);
    Object.keys(st.dims).forEach(function (k) { if (k !== dim && st.dims[k].length) q.set(k, st.dims[k].join(",")); });
    if (vaerdier && vaerdier.length) q.set(dim, vaerdier.join(","));
    if (st.brands.length) q.set(MAERKE, st.brands.join(","));
    if (st.stock) q.set(LAGER, "1");
    if (st.liked) q.set(LIKED, "1");
    if (st.tilbud) q.set(TILBUD, "1");
    if (st.price) q.set(PRIS, st.price[0] + "-" + st.price[1]);
    if (st.sort) q.set(SORT, st.sort);
    return sti + (q.toString() ? "?" + q.toString() : "");
  }

  function isFiltered(st) {
    return !!(Object.keys(st.dims).some(function (k) { return st.dims[k].length; })
      || st.brands.length || st.price || st.stock || st.liked || st.tilbud || st.sort);
  }

  /* PRISEN PATCHES IKKE HER. Fjernet igen 2026-09-22.
     Her stod `applyCampaignPrices`, som lagde kampagnefeedets pris ind i
     facet-rækkerne. Den var en fejldiagnose: endorse-overlay.js patcher allerede
     pris, lagerstatus og før-pris for hele kataloget fra /api/bundles/live, og
     DEN kilde er Shopifys egen pris, læst i samme request der beviste at varen
     er ACTIVE — altså den pris kurven opkræver. Det jeg så den 21., var at
     overlayet endnu ikke havde hentet den nye pris (60 sekunders CDN-cache plus
     to minutters sessionStorage), ikke et hul.
     Bagsiden var værre end fejlen: funktionen kørte EFTER merge() og vandt
     dermed over overlayet, stik imod dens egen regel. Når Shopify var forkert,
     ville gitteret vise den pris kampagnen ønskede, mens kurven opkrævede den
     Shopify havde. To tal på samme skærm, og den næste drift usynlig. */

  /* ------------------------------------------------------------ filtrering */
  /* Nedsat er TO ting, og begge skal tælle (Ajmal-kampagnen 2026-09-02 viste hullet):
     compare-at i selve prisen (samme regel som kortets sale-markering, pris over nul
     så en vare uden e-com-pris ikke tæller som nedsat med 100 %) — OG en live
     kampagne. Siden 2026-09-17 skriver kampagner den nedsatte pris direkte som
     product.price, og endorse-overlay.js patcher både pris og før-pris ind i
     facet-rækkerne fra /api/bundles/live. compare-at alene ville altså som regel
     række — men overlayet kan være op til et minut bagud, og feedet kender
     kampagnen med det samme. Derfor tæller BEGGE. Mangler mappet endnu (feedet
     er async), falder vi tilbage til compare-at, og endorse:campaigns-hændelsen
     tegner om når det lander. */
  function onTilbud(p) {
    if (p.compareAt > p.price && p.price > 0) return true;
    var m = window.EndorseCampaignMap;
    return !!(m && m[p.handle] && p.price > 0);
  }
  // Values within one dimension are OR'd, dimensions are AND'd — the behaviour shoppers
  // expect, and something Shopify's own filters only manage with configuration.
  function matches(p, st, skipKey) {
    var k;
    for (k in st.dims) {
      if (k === skipKey || !st.dims[k].length) continue;
      var have = p.attrs[k];
      if (!have) return false;
      var hit = false;
      for (var i = 0; i < st.dims[k].length; i++) if (have.indexOf(st.dims[k][i]) > -1) { hit = true; break; }
      if (!hit) return false;
    }
    if (skipKey !== MAERKE && st.brands.length && st.brands.indexOf(p.brand) < 0) return false;
    if (skipKey !== LAGER && st.stock && !p.avail) return false;
    // Favoritter afgøres af browserens egen liste (theme.js), ikke af facets —
    // guarded, så et defekt theme.js aldrig kan tømme gitteret.
    if (skipKey !== LIKED && st.liked && !(window.EndorseLikes && window.EndorseLikes.has(p.handle))) return false;
    if (skipKey !== TILBUD && st.tilbud && !onTilbud(p)) return false;
    if (skipKey !== PRIS && st.price) {
      var kr = p.price / 100;
      if (kr < st.price[0] || kr > st.price[1]) return false;
    }
    return true;
  }

  function sortProducts(list, sort) {
    var out = list.slice();
    if (sort === "pris-op") out.sort(function (a, b) { return (a.price || 1e9) - (b.price || 1e9); });
    else if (sort === "pris-ned") out.sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
    else if (sort === "titel") out.sort(function (a, b) { return a.title.localeCompare(b.title, "da"); });
    else if (sort === "lager") out.sort(function (a, b) { return (b.avail ? 1 : 0) - (a.avail ? 1 : 0); });
    /* POPULAER (Anne, 2026-09-09): "de bedste varer skal komme foerst". Tallet er
       en blanding af salg og sidevisninger, regnet ved byggetid af
       _byg-popularitet.mjs og lagt i facet-raekkens kolonne 15.

       LIGE POINT BEHOLDER SIN PLADS. De fleste varer staar paa 0 endnu — butikken
       er ung — og en usttabil sortering ville saa blande gitteret tilfaeldigt om
       hver gang siden tegnes. Array.prototype.sort er stabil i alle browsere vi
       understoetter (ES2019), saa varer med samme tal bliver staaende i den
       raekkefoelge de kom ind, altsaa serverens "Anbefalet". Sorteringen kan
       dermed kun loefte noget op; den kan ikke goere listen daarligere end den er
       i dag. */
    else if (sort === "populaer") out.sort(function (a, b) { return (b.pop || 0) - (a.pop || 0); });
    return out;
  }

  /* --------------------------------------------------------------- kortet */
  // Mirrors snippets/product-card.liquid. Keep the two in step if the card changes.
  // ?-bevidst, ikke naiv sammensætning. Begge generatorer stripper ?v= i dag, så en
  // rå '+ "?width=600"' virker tilfældigvis. Beholder en build nogensinde
  // versionsparameteren, ville den naive form give "...?v=123?width=600" og bryde
  // hvert eneste kort lydløst. Samme form som sizedImg() i theme.js.
  function sized(u, w) { return esc(u) + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w; }

  // Mærket står i kortets øverste hjørne og skal derfor ikke gentages forrest i
  // titlen. Et rent præfiks-tjek er ikke nok: målt på kataloget fejler det på 113
  // af 1140 varer, fordi vendor og titel staves forskelligt ("L'Oréal Paris" mod
  // "L'Oreal Paris" i titlen) eller fordi vendor er længere end det titlen bruger
  // ("Revlon Professional" mod bare "Revlon"). Derfor: æd ét titelord ad gangen så
  // længe de akkumulerede ord stadig er et PRÆFIKS af mærkets handle. Handle-formen
  // folder accenter og tegnsætning væk, og præfiks-kravet (ikke "indeholder")
  // forhindrer at fx "Doo" ædes bare fordi "doozie" indeholder det.
  // Samme algoritme i snippets/product-card.liquid — hold de to i sync.
  function handleize(s) {
    return (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function stripBrand(title, brand) {
    var t = title || "";
    if (!brand) return t;
    var vh = handleize(brand), words = t.split(/\s+/), acc = "", drop = 0;
    for (var i = 0; i < words.length && i < 8; i++) {
      var candRaw = (acc ? acc + " " : "") + words[i];
      var cand = handleize(candRaw);
      if (vh.slice(0, cand.length) !== cand) break;
      acc = candRaw;
      drop = i + 1;
    }
    var rest = words.slice(drop).join(" ").trim();
    return rest || t;          // aldrig en tom titel, hvis navnet ER mærket
  }

  /* Stoerrelsen ud af titlen — SAMME regel som snippets/titel-stoerrelse.liquid.
     De to SKAL give samme svar: Liquid tegner foerste sidevisning, den her
     tegner alt efter foerste filterklik, og et kort der skifter titel naar man
     saetter et filter er vaerre end en lang titel. Aendres reglen ét sted,
     skal den aendres begge steder og maales om med _titel-analyse2.mjs. */
  var TS_ENHEDER = ["tabletter", "servietter", "breve", "stk", "ml", "cl", "kg", "gr", "oz", "cm", "mm", "g", "l"];
  // Staar der en aaben parentes tilbage, var stoerrelsen en del af parentesen
  // ("Gel Mask (4 x 28 g)"), og saa bliver titlen hel. Samme regel i snippettet.
  /* Hjaelpelinjen under maerket — SAMME regel som snippets/product-card.liquid:
     Finish, ellers Haarbehov, ellers Hudtype ("Alle" ved 5+), hoejst to vaerdier i alfabetisk orden. */
  function hjaelpLinje(a) {
    a = a || {};
    if (a.finish && a.finish.length) return "Finish: " + a.finish.slice().sort().slice(0, 2).join(", ");
    if (a.haarbehov && a.haarbehov.length) return "Hårbehov: " + a.haarbehov.slice().sort().slice(0, 2).join(", ");
    if (a.hudtype && a.hudtype.length >= 5) return "Hudtype: Alle";
    if (a.hudtype && a.hudtype.length) return "Hudtype: " + a.hudtype.slice().sort().slice(0, 2).join(", ");
    return "";
  }
  function splitSize(t) {
    var s = splitSizeRaa(t);
    if (s.str && s.ren.split("(").length !== s.ren.split(")").length) return { str: "", ren: (t || "").trim() };
    return s;
  }
  function splitSizeRaa(t) {
    t = (t || "").trim();
    var ord = t.split(" ");
    var n = ord.length;
    if (n < 2) return { str: "", ren: t };
    var afkort = function (k) {
      k = k.trim();
      if (/[,\-:;]$/.test(k)) k = k.slice(0, -1).trim();
      return k;
    };
    var sidste = ord[n - 1].toLowerCase().replace(/\)/g, "").replace(/[.,]$/, "");
    var tal, kandidat;
    // A: "… 50 ml" — tallet er sit eget ord lige foer enheden
    if (n >= 3 && TS_ENHEDER.indexOf(sidste) !== -1) {
      tal = parseFloat(ord[n - 2].replace("(", "").replace(",", "."));
      if (tal > 0) {
        kandidat = afkort(ord.slice(0, n - 2).join(" "));
        if (kandidat.length >= 8) return { str: ord[n - 2].replace("(", "").replace(".", ",") + " " + sidste, ren: kandidat };
      }
    }
    // B: "… 500ml" — tal og enhed klistret sammen
    for (var i = 0; i < TS_ENHEDER.length; i++) {
      var u = TS_ENHEDER[i];
      if (sidste.length > u.length && sidste.slice(-u.length) === u) {
        var forlen = sidste.length - u.length;
        tal = parseFloat(sidste.slice(0, forlen).replace(",", "."));
        if (tal > 0) {
          kandidat = afkort(ord.slice(0, n - 1).join(" "));
          if (kandidat.length >= 8) return { str: sidste.slice(0, forlen).replace(".", ",") + " " + u, ren: kandidat };
        }
        break;
      }
    }
    return { str: "", ren: t };
  }

  /* Laengste FAELLES ordprefix paa tvaers af delenavnene. Samme regel som
     product-card.liquid: mindst to dele, og aldrig hele navnet. */
  function faellesPrefix(navne) {
    if (!navne || navne.length < 2) return "";
    var ord = navne[0].split(" "), kand = "";
    for (var i = 0; i < Math.min(10, ord.length); i++) {
      var proev = kand ? kand + " " + ord[i] : ord[i];
      var alle = navne.every(function (n) { return n.slice(0, proev.length) === proev && n.length > proev.length; });
      if (!alle) break;
      kand = proev;
    }
    return kand;
  }

  function cardHTML(p) {
    var img = p.img
      ? '<img class="product-card__image" src="' + sized(p.img, 600) + '" srcset="'
        + sized(p.img, 400) + ' 400w, ' + sized(p.img, 600) + ' 600w, ' + sized(p.img, 800) + ' 800w" '
        + 'sizes="(min-width: 1280px) 20vw, (min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw" alt="' + esc(p.title) + '" loading="lazy" decoding="async">'
      : '<div class="product-card__image product-card__image--placeholder"></div>';
    var price = money(p.price);
    var onSale = p.compareAt > p.price && p.price > 0;
    var ts = splitSize(stripBrand(p.title, p.brand));
    // Liked-state renderes INLINE: gitteret bygges om ved hvert filter, og en
    // efterfølgende maling ville blinke. data-handle bærer ønskelisten — samme
    // attribut som Liquid-kortet sætter.
    var liked = !!(window.EndorseLikes && window.EndorseLikes.has(p.handle));
    // BUNDLE-KORTETS TEKSTLAG. Delens navn under sin egen vare, samlet pris
    // nederst i midten — samme layout og samme procenter som Liquid-kortet og som
    // pakkefotoet selv tegnes med. Navnene kommer fra facet-raekkens kolonne 13,
    // fordi JS-gitteret hverken ser metafelter eller tags; uden dem ville
    // bundle-kortene miste teksten ved foerste filterklik.
    var pladser = 0, spaend = true;
    if (p.parts) {
      for (var q = 0; q < p.parts.length; q++) pladser += p.parts[q][1];
      if (pladser > 4) { pladser = p.parts.length; spaend = false; }
    }
    var packshot = p.parts
      ? '<div class="product-card__packshot" style="--pladser: ' + pladser + '">'
        + '<ul class="product-card__packshot-navne" role="list">'
        // Stoerrelsen OG det faelles ordprefix ud af delenavnet, samme regel som
        // Liquid-kortet — ellers skifter bundle-kortets tekst ved foerste filterklik.
        + (function () {
            var rene = p.parts.map(function (d) { return splitSize(d[0]).ren; });
            var faelles = faellesPrefix(rene);
            return p.parts.map(function (d, i) {
              var navn = rene[i];
              var unik = navn, fael = "";
              if (faelles) {
                var rest = navn.slice(faelles.length + 1).trim();
                if (rest) { unik = rest; fael = faelles + " "; }
              }
              return '<li style="--span: ' + (spaend ? d[1] : 1) + '">'
                + (fael ? '<span class="product-card__pk-faelles">' + esc(fael) + "</span>" : "")
                + esc(unik) + "</li>";
            }).join("");
          })()
        + "</ul>"
        + '<p class="product-card__packshot-pris" data-price="' + p.price + '">' + price + "</p>"
        + "</div>"
      : "";
    return '<article class="product-card' + (p.parts ? " product-card--bundle" : "") + '" data-handle="' + esc(p.handle) + '">'
      + '<a class="product-card__media-link" href="/products/' + esc(p.handle) + '" aria-label="' + esc(p.title) + '">'
        + '<div class="product-card__media">' + img + packshot
          + '<div class="product-card__top">'
            + (p.brand ? '<p class="product-card__brand">' + esc(p.brand) + "</p>" : "")
            + (hjaelpLinje(p.attrs) ? '<p class="product-card__hjaelp">' + esc(hjaelpLinje(p.attrs)) + "</p>" : "")
            // Udsolgt-badget skal ogsaa staa i det FILTREREDE gitter, ellers
            // forsvinder lagerstatus i samme oejeblik man saetter et filter.
            // Badges: samme raekkefoelge og samme klasser som Liquid-kortet.
            // Bundle-flaget kommer fra facet-raekken (row[12]) og ikke fra tags,
            // fordi JS-gitteret aldrig ser produktets tags.
            + ((!p.avail || p.bundle) ? '<div class="product-card__badges">'
                + (p.avail ? "" : '<span class="product-card__badge product-card__badge--sold">Udsolgt</span>')
                + (p.bundle ? '<span class="product-card__badge product-card__badge--bundle">Bundle</span>' : "")
              + "</div>" : "")
          + "</div>"
        + "</div></a>"
      + '<button type="button" class="product-card__heart' + (liked ? " is-liked" : "") + '" aria-pressed="' + (liked ? "true" : "false") + '" aria-label="' + (liked ? "Fjern fra ønskelisten" : "Tilføj til ønskelisten") + '">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l8.84 8.84 8.84-8.84a5.5 5.5 0 0 0 0-7.78z"/></svg>'
      + '</button>'
      // Ingen quick-add: knappen er fjernet fra kortet 2026-08-31, og lagerstatus
      // staar som badge i oeverste venstre hjoerne. Se snippets/product-card.liquid.
      + '<div class="product-card__content"><div class="product-card__content-left">'
        + '<h3 class="product-card__title"><a href="/products/' + esc(p.handle) + '">'
        + esc(ts.ren)
        + (ts.str ? '<span class="product-card__title-size"> ' + esc(ts.str) + "</span>" : "")
        + "</a></h3>"
      + '</div><div class="product-card__content-right">'
        // data-price (øre) læses af campaign-live.js — kampagnerabat regnes på
        // det rå tal. −N%-chippen for compare-at matcher nu Liquid-kortet.
        + '<div class="product-card__prisrow">'
          + (ts.str ? '<span class="product-card__size">' + esc(ts.str) + "</span>" : "")
          + (price ? '<div class="product-card__price' + (onSale ? " is-sale" : "") + '" data-price="' + p.price + '">' + price + "</div>" : "")
        + "</div>"
        + (onSale ? '<div class="product-card__price-compare">' + money(p.compareAt) + "</div>" : "")
        + (onSale ? '<div class="product-card__discount">−' + Math.round((1 - p.price / p.compareAt) * 100) + "%</div>" : "")
      + "</div></div></article>";
  }

  /* ------------------------------------------------------------- motoren */
  /* FILTERBAREN ER VALGFRI (2026-09-09). Kollektioner uden filter-matrix får ingen
     bar (sections/collection.liquid), men skal stadig have gitter, paginering og
     den flydende model. Se den lange note inde i init(). */
  function init(root) {
    var grid = root.querySelector("[data-grid]");
    var bar = root.querySelector(".plp__filterbar");
    if (!grid) return;

    var cat = root.getAttribute("data-plp-cat") || "";
    var sub = root.getAttribute("data-plp-sub") || "";
    /* TYPESIDE (Searchmind 2026-09-21): data-plp-type baerer de produkttype-vaerdier siden
       samler (fx "Foundation" eller "Voks & pomade|Ler & paste"), adskilt af |. Siden scoper
       paa kategori + produkttype, IKKE paa hylde (data-plp-sub er tom): concealer ligger 22 paa
       ansigt og 5 paa oejne, leave-in paa 6 hylder. Uden dette toemte foerste filterklik
       gitteret, praecis som Maend uden _meta.also. */
    var typer = (root.getAttribute("data-plp-type") || "").split("|").filter(Boolean);
    /* Hvilken DIMENSION siden hviler paa. De 18 foerste er produkttyper, men en typeside kan lige
       saa godt vaere en aktiv (Retinol) eller en egenskab (Parfumefri) — Mikkel 2026-09-22.
       Mekanismen er den samme; kun noeglen skifter. */
    var typeDim = root.getAttribute("data-plp-dim") || "produkttype";
    /* TYPESIDER I DROPDOWNEN (Mikkel 2026-09-21: "en helt normal dropdown i filteret ligesom det
       allerede er under produkttype; det filter skal bare tage dig til den nye kategoriside").
       D.typesider (catalog-facets.json) kobler "<kategori>/<produkttype>" til sidens URL. I
       Produkttype-dropdownen tegnes de vaerdier som LINKS: paa hylden/kategorien linker
       "Foundation" til /collections/foundation, paa typesiden selv staar dens egen vaerdi som
       valgt og linker OP (data-plp-op: hylden eller kategorien), og soeskende-typesiderne staar
       med som links med kategoriens tal, saa dropdownen ikke er tom paa en side med én type. */
    var opUrl = root.getAttribute("data-plp-op") || "";
    function typesideFor(dim, v) { return (D && D.typesider && D.typesider[cat + "/" + dim + "/" + v]) || ""; }
    // Har denne dimension overhovedet sider i kategorien? Ellers er et klik altid bare et filter.
    function dimHarSider(dim) {
      if (!D || !D.typesider) return false;
      var p = cat + "/" + dim + "/";
      for (var k in D.typesider) if (k.indexOf(p) === 0) return true;
      return false;
    }

    /* ET FILTER DER OGSAA ER EN NAVIGATION (Mikkel 2026-09-22).
       Valget ser ud som ethvert andet filter. Reglen ligger i hvad klikket goer:

         praecis ÉN vaerdi valgt, og den har en side  ->  gaa til den side ("/collections/retinol")
         ingen vaerdi valgt, og vi staar paa en side  ->  gaa OP til hylden/kategorien (data-plp-op)
         flere vaerdier valgt, og vi staar paa en side ->  gaa ud i KATEGORIEN med dem alle
         alt andet                                    ->  bliv, og filtrér som foer

       Den tredje regel skal gaa til kategorien og ikke til hylden: to vaerdier kan ligge paa hver
       sin hylde (concealer paa ansigt, lipgloss paa laeber), og paa hylden ville den ene blive
       filtreret vaek. Staar man PAA en hylde, sker der ingen navigation ved flere vaerdier — dér
       er man med vilje begraenset til hyldens egne.

       Reglen gaelder ENHVER dimension der har sider i kategorien: produkttype for de 18 foerste,
       aktiver for Retinol, egenskaber for Parfumefri. `dim` er den dropdown der blev klikket i;
       `typeDim` er den dimension SIDEN hviler paa, og de to er kun ens naar man staar paa en side
       af samme slags.

       Navigationen er en rigtig sideskift (location.assign), ikke en udskiftning af gitteret:
       serveren skal render'e den rigtige collection, og tilbage-knappen skal virke bagefter. */
    function filterKlik(dim, v) {
      if (!D || !D.typesider || !dimHarSider(dim)) return false;
      var paaSide = typer.length > 0 && dim === typeDim;
      var valgt = (st.dims[dim] || []).slice();
      if (paaSide) typer.forEach(function (t) { if (valgt.indexOf(t) < 0) valgt.push(t); });
      var at = valgt.indexOf(v);
      if (at > -1) valgt.splice(at, 1); else valgt.push(v);

      if (valgt.length === 1) {
        var side = typesideFor(dim, valgt[0]);
        // Staar vi allerede paa netop den side, er der intet at gaa til.
        if (side && !(paaSide && typer.length === 1 && typer[0] === valgt[0])) { location.assign(urlTil(side, st, dim, null)); return true; }
      }
      if (!paaSide) return false;                            // paa hylde/kategori: almindeligt filter
      if (!valgt.length) { location.assign(urlTil(opUrl || ("/collections/" + cat), st, dim, null)); return true; }
      location.assign(urlTil("/collections/" + cat, st, dim, valgt));
      return true;
    }
    /* `__serverGrid` er gitteret som SERVEREN sendte det, uden kampagnefelter.
       Snippettet campaign-tiles.liquid lægger det til side inden det skyder
       felterne ind, og det er nødt til at være den vej rundt: felterne indsættes
       inline under parsing, mens denne fil er deferred, så et rent
       `grid.innerHTML` her ville allerede indeholde dem — og så blev de bagt ind
       i snapshottet og duplikeret ved hver eneste gentegning. */
    var serverGrid = grid.__serverGrid !== undefined ? grid.__serverGrid : grid.innerHTML;
    var serverPager = root.querySelector(".plp__pagination, .search-page__pagination");
    /* UDEN FILTERBAR. Kollektioner der ikke er en af de syv kategorier har ingen
       filter-matrix, og sections/collection.liquid udelader derfor baren med vilje
       (fast-lave-priser, 990 varer). To ting følger af det:

       a) Filtre skal IGNORERES. Kollektionen har intet udsnit i catalog-facets.json,
          så baseSet() giver en TOM liste, og et ?maerke= i URL'en ville tegne et tomt
          gitter — præcis det baren blev udeladt for at undgå. Uden bar er der heller
          ingen UI til at se eller rydde et filter med. Vi læser derfor kun sidetallet.
       b) Men resten af laget skal KØRE. Før 2026-09-09 afbrød init() på den manglende
          bar, og så stod siden tilbage på serverens 26 varer pr. side, mens
          felt-motoren havde bedt om 28 eller 30 og lagt pladsholdere ind som ingen
          fyldte. Mikkel: "siderne mangler ofte 4 produkter pr. side ... det er som om
          de ikke er opdateret med vores nyeste flow". Præcis dét. */
    function laesState() {
      var s = readState();
      if (bar) return s;
      return { dims: {}, brands: [], price: null, stock: false, liked: false,
               tilbud: false, sort: "", q: s.q, page: s.page };
    }
    var st = laesState();
    var D = null;               // facets data
    var base = [];              // the products this page is about
    // True on the search page, where the result set comes from our own index and must
    // always be rendered — the server markup there is only a no-JS fallback.
    var ownResults = false;

    /* --- fyld-tilstanden: serverens sider, lånt frem i SERVERENS rækkefølge --- */
    var total = parseInt(grid.getAttribute("data-total"), 10) || 0;
    var serverPage = st.page;   // den side serveren faktisk har tegnet (?page=N)
    var kortCache = {};         // server-sidetal → [kort-HTML …] i Shopifys rækkefølge
    var fyldToken = 0;
    function splitKort(html) {
      var t = document.createElement("template");
      t.innerHTML = html;
      var out = [];
      t.content.querySelectorAll(".product-card:not(.product-card--filler)").forEach(function (el) {
        out.push(el.outerHTML);
      });
      return out;
    }
    function handleOf(html) {
      var m = /data-handle="([^"]*)"/.exec(html);
      return m ? m[1] : "";
    }
    kortCache[serverPage] = splitKort(serverGrid);
    /* `?view=kort` er templates/collection.kort.liquid: samme `paginate … by 26`,
       samme kort-snippet, uden layout — så side k derfra er præcis side k her.
       catalog-facets kan ikke bruges: kollektionerne sorterer efter bedst
       sælgende, og den rækkefølge findes kun hos serveren. */
    function hentKort(k) {
      if (kortCache[k]) return Promise.resolve(kortCache[k]);
      return fetch(location.pathname + "?view=kort&page=" + k, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("kort " + k + ": " + r.status); return r.text(); })
        .then(function (html) { kortCache[k] = splitKort(html); return kortCache[k]; });
    }
    /* FLYDENDE (2026-09-08, se "FLYDENDE" i campaign-tiles.liquid): kan motoren
       regne kæden af sider? Kræver at puljen er afgjort og mindst to kolonner.
       Den ufiltrerede kategoriside kræver også data-total. */
    function flydKlar() {
      var E = window.EndorseCampaigns;
      return !!(E && E.sider && grid.__campPool && colsOf(grid) >= 2);
    }
    function keyBase() {
      var m = /^(.*):\d+$/.exec(grid.__campKey || "");
      return m ? m[1] : (grid.__campKey || cat || "grid");
    }
    /* Filtersignatur UDEN sidetal: kæden skal være den samme for alle sider i
       samme filtrering, ellers flytter varerne sig fra side til side. */
    function filterSig() {
      return (st.sort || "") + "|" + JSON.stringify(st.dims) + "|" + st.brands.join(",")
        + "|" + (st.price ? st.price.join("-") : "") + "|" + (st.stock ? "1" : "0")
        + "|" + (st.liked ? "1" : "0") + "|" + (st.tilbud ? "1" : "0") + "|" + (st.q || "");
    }
    function afsloerGrid() { document.documentElement.classList.remove("camp-venter"); }
    function planSig(s) {
      return JSON.stringify((s && s.placed || []).map(function (p) { return [p.at, p.size.cs, p.size.rs, p.camp && p.camp.id]; }));
    }
    function sammePlan(s) {
      return !!grid.__campSide && planSig(grid.__campSide) === planSig(s)
        && grid.querySelectorAll(".camp-tile").length === (s.placed || []).length;
    }

    function baseSet() {
      // On search, the header engine decides which products are relevant; on a collection
      // page it is simply the category (and subcategory) the shopper is browsing.
      // `!== null`, ikke sandhedsværdi. En søgning UDEN træf sætter attributten til en
      // tom streng, og `if (handles)` var derfor falsk — så faldt vi igennem til
      // kategori-scopet, hvor `cat` er "" på søgesiden, og siden viste HELE kataloget
      // som svar på en søgning der intet fandt. Målt på live 2026-08-12: /search?q=
      // dermalogica gav 1240 resultater efter mærket var skjult. Attributtens
      // TILSTEDEVÆRELSE betyder "søgningen har svaret", uanset om svaret er tomt.
      var handles = root.getAttribute("data-plp-handles");
      if (handles !== null) {
        if (!handles) return [];
        return handles.split(",").map(function (h) { return D.byHandle[h]; }).filter(Boolean);
      }
      // /collections/all er Shopifys "alle produkter" og er IKKE en af vores kategorier.
      // Uden dette matchede `p.cat === "all"` ingenting: baren viste "0 produkter" på en
      // side hvor serveren havde render'et 25, og de 41 søgegenveje der ikke er
      // kategori-scopede (de peger alle på /collections/all) filtrerede alt væk.
      // Målt på live 2026-08-07: /collections/all?hudbehov=Rødme & irritation gav 0 kort.
      var scope = cat === "all" ? "" : cat;
      /* SIDER DER LIGNER EN KATEGORI MEN IKKE ER EN (Nanna @ Searchmind, 2026-09-22):
         /collections/tilbud har endorse.subcategories og filter_matrix, saa den faar en filterbar
         — men INGEN vare har p.cat === "tilbud", for tilbud er et tag, ikke en kategori. Derfor
         var grundmaengden tom, og foerste klik paa "Kun paa lager" eller "Tilbud" gjorde 26 kort
         til 0. Samme klasse af fejl som /collections/all havde.

         Et scope vi ikke kender som kategori faar sin egen praedikat her. Tilbudssiden ER
         "varer paa tilbud", og onTilbud() er praecis den samme proeve som Tilbud-chippen bruger,
         saa side og filter kan ikke komme i utakt. Er scopet ukendt OG uden praedikat, falder vi
         tilbage til hele kataloget: for meget er en synlig fejl, nul er en usynlig. */
      // "black-november": tilbudssidens handle under kampagnen (2026-10-30). Samme side, samme praedikat.
      var SPECIALSCOPE = { tilbud: onTilbud, "black-november": onTilbud };
      var erKategori = !scope || (D.cats && D.cats.indexOf(scope) > -1);
      var specialFn = erKategori ? null : (SPECIALSCOPE[scope] || null);
      function harType(p) {
        if (!typer.length) return true;
        var have = p.attrs[typeDim];
        if (!have) return false;
        for (var t = 0; t < typer.length; t++) if (have.indexOf(typer[t]) > -1) return true;
        return false;
      }
      return D.produkter.filter(function (p) {
        if (!harType(p)) return false;
        if (!erKategori) return specialFn ? specialFn(p) : true;
        if ((!scope || p.cat === scope) && (!sub || p.sub === sub)) return true;
        // Varen kan også stå på en sekundær hylde (CeraVe under både ansigtscreme og
        // bodylotion). Serveren render'er den dér; gitteret skal beholde den.
        if (!p.also) return false;
        for (var i = 0; i < p.also.length; i++) {
          if ((!scope || p.also[i][0] === scope) && (!sub || p.also[i][1] === sub)) return true;
        }
        return false;
      });
    }

    function current() {
      return base.filter(function (p) { return matches(p, st); });
    }

    /* --- counts, recomputed against every OTHER active filter --- */
    function countsFor(key) {
      var pool = base.filter(function (p) { return matches(p, st, key); });
      var out = {};
      pool.forEach(function (p) {
        if (key === MAERKE) { out[p.brand] = (out[p.brand] || 0) + 1; return; }
        if (key === LAGER) { if (p.avail) out["1"] = (out["1"] || 0) + 1; return; }
        var vals = p.attrs[key];
        if (vals) vals.forEach(function (v) { out[v] = (out[v] || 0) + 1; });
      });
      return out;
    }

    function renderOptions(group) {
      var key = group.getAttribute("data-group");
      var box = group.querySelector("[data-opts]");
      if (!box || key === PRIS) return;
      var counts = countsFor(key);
      var active = key === MAERKE ? st.brands : (st.dims[key] || []);
      /* PAA EN TYPESIDE taelles produkttyperne paa HELE kategorien, ikke paa siden. Uden det
         ville listen kun indeholde sidens egen vaerdi, knappen ville skjule sig selv
         (values.length < 2), og man kunne hverken slaa typen fra eller vaelge en mere.
         Tallet er samtidig det man FAAR: vaelger man en type mere, lander man i kategorien.
         Paa en hylde taelles der som altid paa hylden — dér er man begraenset til hyldens typer. */
      if (key === typeDim && typer.length && cat && cat !== "all") {
        counts = {};
        D.produkter.forEach(function (p) {
          if (p.cat !== cat || !p.attrs[key]) return;
          p.attrs[key].forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
        });
      }
      var values = Object.keys(counts).sort(function (a, b) {
        // Mærker står ALFABETISK (Anne, 2026-09-03). Man leder efter et navn man
        // kender, og så er "flest først" bare uorden. Attributværdier beholder
        // flest-først, for dér ved man ikke på forhånd hvad der findes.
        if (key !== MAERKE && counts[b] !== counts[a]) return counts[b] - counts[a];
        return a.localeCompare(b, "da");
      });
      // Keep an applied value visible even when nothing else matches it any more.
      active.forEach(function (v) { if (values.indexOf(v) < 0) values.push(v); });

      // A dimension with nothing to offer on this page removes itself. That is how a hair
      // filter can never appear on a serum page — the failing that Lyko ships today.
      group.hidden = values.length < 2;

      box.innerHTML = values.map(function (v) {
        var on = active.indexOf(v) > -1;
        var n = counts[v] || 0;
        /* Sidens egen vaerdi staar afkrydset som et helt almindeligt filter (Mikkel 2026-09-22:
           "de skal istedet bare have en boks"), uanset hvilken dimension siden hviler paa.
           Forskellen ligger i hvad KLIKKET goer, ikke i hvordan valget ser ud: se filterKlik(). */
        if (key === typeDim && typer.indexOf(v) > -1) on = true;
        // is-checked drives the visible tick — .plp__fbox renders its checkmark in
        // currentColor, which is transparent until the option is marked active.
        return '<a class="plp__fopt' + (on ? " is-checked" : "") + (n === 0 && !on ? " is-disabled" : "") + '" href="#"'
          + ' data-val="' + esc(v) + '" data-fopt-label="' + esc(String(v).toLowerCase()) + '">'
          + '<span class="plp__fbox">' + (on ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' : "")
          + "</span><span>" + esc(v) + ' <span class="plp__fopt-count">(' + n + ")</span></span></a>";
      }).join("") || '<div class="plp__fempty">Ingen værdier her</div>';

      // Sidens egen type taeller med i badgen: den ER et aktivt produkttype-valg, selv om den
      // staar i URL'en i stedet for i st.dims.
      var count = active.length + (key === typeDim ? typer.length : 0);
      group.classList.toggle("is-active", count > 0);
      var badge = group.querySelector(".plp__fcount");
      var btn = group.querySelector(".plp__fbtn");
      if (count > 0 && !badge && btn) {
        badge = document.createElement("span");
        badge.className = "plp__fcount";
        btn.insertBefore(badge, btn.querySelector(".plp__fchev"));
      }
      if (badge) { badge.textContent = count; badge.hidden = count === 0; }
    }

    function renderPrice() {
      var group = root.querySelector('[data-group="' + PRIS + '"]');
      if (!group) return;
      var pool = base.filter(function (p) { return matches(p, st, PRIS); });
      var max = 0;
      pool.forEach(function (p) { if (p.price > max) max = p.price; });
      max = Math.ceil(max / 100) || 1000;
      var slider = group.querySelector("[data-price-slider]");
      if (!slider) return;
      var lo = group.querySelector("[data-slider-min]"), hi = group.querySelector("[data-slider-max]");
      slider.setAttribute("data-max", max);
      lo.max = max; hi.max = max;
      lo.value = st.price ? Math.min(st.price[0], max) : 0;
      hi.value = st.price ? Math.min(st.price[1], max) : max;
      if (window.EndorseInitPriceSlider) window.EndorseInitPriceSlider(slider);
      group.classList.toggle("is-active", !!st.price);
    }

    function renderChips() {
      if (!bar) return;   // ingen bar = ingen filtre at vise chips for
      var wrap = root.querySelector(".plp__chips");
      var chips = [];
      // Staar vi paa en typeside, ER sidens produkttype et aktivt valg. Den vises som en chip
      // ligesom ethvert andet filter, og krydset fører op til hylden — ellers ville dropdownen
      // vise et afkrydset valg som chiprækken ikke kendte til.
      typer.forEach(function (v) { chips.push({ k: typeDim, v: v, label: v }); });
      Object.keys(st.dims).forEach(function (k) {
        st.dims[k].forEach(function (v) { chips.push({ k: k, v: v, label: v }); });
      });
      st.brands.forEach(function (b) { chips.push({ k: MAERKE, v: b, label: b }); });
      if (st.stock) chips.push({ k: LAGER, v: "1", label: "På lager" });
      if (st.liked) chips.push({ k: LIKED, v: "1", label: "Favoritter" });
      if (st.tilbud) chips.push({ k: TILBUD, v: "1", label: "Tilbud" });
      if (st.price) chips.push({ k: PRIS, v: "", label: st.price[0] + "-" + st.price[1] + " kr" });

      if (!chips.length) { if (wrap) wrap.remove(); return; }
      if (!wrap) {
        wrap = document.createElement("div");
        wrap.className = "plp__chips";
        bar.appendChild(wrap);
      }
      wrap.innerHTML = chips.map(function (c) {
        return '<a class="plp__chip-btn" href="#" data-chip-key="' + esc(c.k) + '" data-chip-val="' + esc(c.v) + '">'
          + esc(c.label) + ' <span style="color:var(--color-ink-mute)">×</span></a>';
      }).join("") + '<a class="plp__chip-clear" href="#" data-chip-clear>Ryd alle</a>';
    }

    /* ---------------------------------------------------------- paginering */
    // Katalogsider har sider, ikke "vis flere". Uden filtre er det serverens egen
    // paginering ({% paginate %}), som er bedst for SEO og første paint. Så snart
    // der filtreres, kender serveren ikke resultatsættet, og så tegner vi selv en
    // pager i præcis samme markup — sidetallet ligger i URL'en ved siden af
    // filtrene, så et sideskift aldrig taber dem.
    function pageParts(cur, total) {
      var out = [];
      for (var i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= cur - 1 && i <= cur + 1)) out.push(i);
        else if (out[out.length - 1] !== "…") out.push("…");
      }
      return out;
    }

    function renderPager(total) {
      var nav = root.querySelector("[data-plp-pager]");
      if (total <= 1) { if (nav) nav.parentNode.removeChild(nav); return; }
      if (!nav) {
        nav = document.createElement("nav");
        nav.className = serverPager && serverPager.className.indexOf("search-page") > -1
          ? "search-page__pagination plp__pagination" : "plp__pagination";
        nav.setAttribute("data-plp-pager", "");
        nav.setAttribute("role", "navigation");
        nav.setAttribute("aria-label", "Paginering");
        grid.parentNode.insertBefore(nav, grid.nextSibling);
      }
      var html = st.page > 1
        ? '<a class="plp__page-arrow" href="#" data-page="' + (st.page - 1) + '" aria-label="Forrige side">←</a>' : "";
      pageParts(st.page, total).forEach(function (p) {
        if (p === "…") html += '<span class="plp__page-gap">…</span>';
        else if (p === st.page) html += '<span class="plp__page is-current" aria-current="page">' + p + "</span>";
        else html += '<a class="plp__page" href="#" data-page="' + p + '">' + p + "</a>";
      });
      if (st.page < total) {
        html += '<a class="plp__page-arrow" href="#" data-page="' + (st.page + 1) + '" aria-label="Næste side">→</a>';
      }
      nav.innerHTML = html;
    }

    function dropPager() {
      var nav = root.querySelector("[data-plp-pager]");
      if (nav) nav.parentNode.removeChild(nav);
    }

    /* Kampagnefelterne overlever ikke en gentegning af sig selv — de ligger i
       den innerHTML vi lige har smidt væk. Derfor genindsættes de efter HVER
       tegning, og altid før fillerne, som skal kunne se dem for at regne rigtigt.
       Nøglen bærer filtertilstanden med, så et filtreret resultat får sit eget
       mønster der til gengæld er stabilt så længe filteret står. */
    /* TOM NØGLE I DEN UFILTREREDE TILSTAND, og det er ikke kosmetik. Felterne er
       allerede sat ind af det inline script i snippetten, som kalder inject()
       uden nøgle. Brugte vi filtersignaturen her, ville den ufiltrerede visning
       trække et ANDET mønster end det der allerede står på skærmen, og felterne
       ville hoppe rundt et øjeblik efter load. Samme tilstand skal give samme
       nøgle, uanset hvem der kalder. */
    function campKey() {
      if (!isFiltered(st) && !ownResults) return "";
      return st.page + "|" + (st.sort || "") + "|" + JSON.stringify(st.dims)
           + "|" + st.brands.join(",") + "|" + (st.price ? st.price.join("-") : "")
           + "|" + (st.stock ? "1" : "0") + "|" + (st.liked ? "1" : "0")
           + "|" + (st.tilbud ? "1" : "0");
    }
    function afterRender() {
      if (window.EndorseCampaigns) window.EndorseCampaigns.inject(grid, campKey());
      if (window.EndorseSyncGrid) window.EndorseSyncGrid(grid);
    }

    /* Står gitteret præcis som serveren sendte det? Ved første kørsel gør det,
       og så må vi ikke røre det. */
    var gridIsServer = true;

    function renderGrid() {
      var list = sortProducts(current(), st.sort);
      /* querySelectorAll og ikke querySelector: tallet staar to steder siden
         filterarket kom til — i baren paa desktop og i arkets triggerlinje paa
         telefon. Med `querySelector` blev kun det foerste opdateret, og det
         andet stod med serverens tal resten af besoeget. */
      root.querySelectorAll(".plp__resultcount strong").forEach(function (el) { el.textContent = list.length; });
      var applyBtn = root.querySelector("[data-sheet-results]");
      if (applyBtn) {
        applyBtn.textContent = list.length === 1 ? "Vis 1 vare" : "Vis " + list.length + " varer";
      }

      if (!isFiltered(st) && !ownResults) {
        if (flydKlar() && total) { renderFlyd(); return; }
        /* Intet filter på en kategoriside: serverens egen side skal stå som
           den er.

           TIDLIGERE SKREV VI serverGrid TILBAGE HVER GANG, også ved den allerførste
           kørsel hvor gitteret allerede indeholdt nøjagtig det. Målt på en strubet
           forbindelse: 55 noder fjernet og 55 lagt ind igen et sekund efter load —
           hele gitteret revet ned og bygget op, med billeder der skulle dekodes
           forfra og kampagnefelter der blev kasseret og trukket på ny. Det var det
           glimt man kunne nå at se. Nu rører vi kun gitteret hvis det faktisk
           STÅR forkert, altså hvis en filtrering har skrevet noget andet ind. */
        if (!gridIsServer) {
          grid.innerHTML = serverGrid;
          gridIsServer = true;
          afterRender();
        } else if (window.EndorseSyncGrid) {
          /* Fillerne er billige og idempotente; theme.js kan endnu ikke have kørt. */
          window.EndorseSyncGrid(grid);
        }
        if (serverPager) serverPager.hidden = false;
        dropPager();
        return;
      }
      gridIsServer = false;
      if (serverPager) serverPager.hidden = true;

      /* FLYDENDE også her: kæden regnes over hele resultatsættet med
         filtersignaturen i nøglen, så et filtreret resultat får sit eget,
         stabile mønster — og hver side lukker, uanset hvilke felter der er. */
      if (list.length && flydKlar()) {
        var E2 = window.EndorseCampaigns, cols2 = colsOf(grid);
        var chain2 = E2.sider(grid.__campPool, list.length, cols2, keyBase() + "|" + filterSig());
        var pages2 = Math.max(1, chain2.length);
        if (st.page > pages2) st.page = pages2;
        var s2 = chain2[st.page - 1];
        grid.innerHTML = list.slice(s2.from, s2.from + s2.cards).map(cardHTML).join("");
        grid.classList.remove("plp__grid--tom");
        E2.injectPlaced(grid, s2.placed, cols2);
        grid.__campSide = s2;
        if (window.EndorseSyncGrid) window.EndorseSyncGrid(grid);
        renderPager(pages2);
        afsloerGrid();
        return;
      }

      var size = pageSizeFor(grid);
      var pages = Math.max(1, Math.ceil(list.length / size));
      if (st.page > pages) st.page = pages;   // fx efter et filter der skærer sidetallet ned
      var from = (st.page - 1) * size;

      if (!list.length) {
        grid.innerHTML = '<p class="plp__noresults">Ingen produkter matcher filtrene. <a href="#" data-chip-clear>Ryd alle</a></p>';
      } else {
        grid.innerHTML = list.slice(from, from + size).map(cardHTML).join("");
      }
      /* Gitterets egen top- og venstrekant er kortenes yderste hairlines. Uden
         kort er de en halv kasse tegnet om én linje tekst, og det er samme fejl
         som de indrammede tomme celler: der hvor der ikke er varer, er der
         heller ikke streger. */
      grid.classList.toggle("plp__grid--tom", !list.length);
      // Kampagnefelter ind igen, og luk så sidste række med fillers (se theme.js).
      afterRender();
      renderPager(list.length ? pages : 1);
    }

    /* Tegn side st.page i DEN FLYDENDE MODEL på den ufiltrerede kategoriside.
       Kæden (motorens sider()) siger hvilke varer [from, to) og hvilke felter
       siden har; kortene hentes fra de server-sider vinduet spænder over
       (?view=kort, cachet pr. sidevisning) i kollektionens egen rækkefølge.
       Står serverens egne kort forrest og intakte — side 1 ved load — bliver
       inline-scriptets pladsholdere til varer på stedet og felterne står hvor
       de står; ellers tegnes siden om i ét hug. */
    function renderFlyd() {
      var E = window.EndorseCampaigns, cols = colsOf(grid);
      var chain = E.sider(grid.__campPool, total, cols, keyBase());
      var pages = Math.max(1, chain.length);
      if (st.page > pages) st.page = pages;
      var s = chain[st.page - 1] || { from: 0, cards: 0, placed: [], area: 0 };
      var from = s.from, to = s.from + s.cards;
      var first = Math.floor(from / PER_PAGE) + 1;
      var last = Math.floor(Math.max(from, to - 1) / PER_PAGE) + 1;
      var token = ++fyldToken;
      if (serverPager) serverPager.hidden = true;
      var hent = [];
      for (var k = first; k <= last; k++) hent.push(hentKort(k));
      Promise.all(hent).then(function (lists) {
        if (token !== fyldToken) return;   // en nyere tegning er sat i gang
        var cards = [];
        lists.forEach(function (l, i) {
          var start = (first + i - 1) * PER_PAGE;
          l.forEach(function (html, j) { var g = start + j; if (g >= from && g < to) cards.push(html); });
        });
        var staar = grid.querySelectorAll(".product-card:not(.product-card--filler):not(.product-card--venter)");
        var pladser = grid.querySelectorAll(".product-card--venter");
        var faelles = 0;
        while (faelles < staar.length && faelles < cards.length
               && staar[faelles].getAttribute("data-handle") === handleOf(cards[faelles])) faelles++;
        var t;
        if (faelles === staar.length && faelles + pladser.length === cards.length) {
          /* Præfikset står. Pladsholderne bliver til varer på stedet. */
          for (var i2 = 0; i2 < pladser.length; i2++) {
            t = document.createElement("template");
            t.innerHTML = cards[faelles + i2];
            pladser[i2].parentNode.replaceChild(t.content.firstChild, pladser[i2]);
          }
          if (!sammePlan(s)) E.injectPlaced(grid, s.placed, cols);
        } else {
          grid.innerHTML = cards.join("");
          E.injectPlaced(grid, s.placed, cols);
        }
        grid.__campSide = s;
        gridIsServer = false;
        grid.classList.toggle("plp__grid--tom", !cards.length);
        if (window.EndorseSyncGrid) window.EndorseSyncGrid(grid);
        renderPager(pages);
        afsloerGrid();
      }).catch(function () {
        /* Kunne ikke hente: serverens side står som den er, fillerne lukker rækken. */
        if (token !== fyldToken) return;
        each(grid.querySelectorAll(".product-card--venter"), function (el) { el.parentNode.removeChild(el); });
        if (window.EndorseSyncGrid) window.EndorseSyncGrid(grid);
        if (serverPager) serverPager.hidden = false;
        afsloerGrid();
      });
    }
    function each(list, fn) { Array.prototype.forEach.call(list, fn); }

    function renderAll() {
      root.querySelectorAll(".plp__fgroup[data-group]").forEach(function (g) {
        var k = g.getAttribute("data-group");
        if (k === PRIS || k === "more") return;
        renderOptions(g);
      });
      // "Flere filtre" folds out a second ROW of buttons rather than opening one tall
      // scrolling panel. It only earns its place when something is actually behind it,
      // and it stays open on its own once a filter down there is in use.
      var moreBtn = root.querySelector("[data-more-toggle]");
      var moreRow = root.querySelector("[data-more-row]");
      if (moreBtn && moreRow) {
        var extras = moreRow.querySelectorAll(".plp__fgroup:not([hidden])");
        var hiddenActive = 0;
        extras.forEach(function (g) {
          var kk = g.getAttribute("data-group");
          hiddenActive += (kk === MAERKE ? st.brands : (st.dims[kk] || [])).length;
        });
        moreBtn.hidden = extras.length === 0;
        if (hiddenActive > 0) moreRow.hidden = false;
        moreBtn.classList.toggle("is-open", !moreRow.hidden);
        var lbl = moreBtn.querySelector("[data-more-label]");
        if (lbl) lbl.textContent = moreRow.hidden ? "Flere filtre" : "Færre filtre";
        var mbadge = moreBtn.querySelector(".plp__fcount");
        if (!mbadge) {
          mbadge = document.createElement("span");
          mbadge.className = "plp__fcount";
          moreBtn.insertBefore(mbadge, moreBtn.querySelector(".plp__fchev"));
        }
        mbadge.textContent = hiddenActive;
        mbadge.hidden = hiddenActive === 0 || !moreRow.hidden;
      }
      /* Talpillen paa "Filtrer"-knappen. Den taeller det samme som chipsene:
         hver valgt vaerdi, plus de tre toggles og prisen som ét hver. Uden den
         kan man ikke se fra den lukkede bar at der ER filtre paa. */
      var sheetCount = root.querySelector("[data-sheet-count]");
      if (sheetCount) {
        var aktive = st.brands.length + (st.price ? 1 : 0)
          + (st.stock ? 1 : 0) + (st.liked ? 1 : 0) + (st.tilbud ? 1 : 0);
        Object.keys(st.dims).forEach(function (k) { aktive += st.dims[k].length; });
        sheetCount.textContent = aktive;
        sheetCount.hidden = aktive === 0;
      }
      renderPrice();
      renderChips();
      renderGrid();
      var toggle = root.querySelector("[data-stock-toggle]");
      if (toggle) toggle.classList.toggle("is-on", st.stock);
      var ltoggle = root.querySelector("[data-liked-toggle]");
      if (ltoggle) ltoggle.classList.toggle("is-on", st.liked);
      var btoggle = root.querySelector("[data-tilbud-toggle]");
      if (btoggle) btoggle.classList.toggle("is-on", st.tilbud);
      markerDisc();
    }

    /* HYLDERÆKKENS MARKERING følger tilbudsfiltret. Tilbud er den eneste cirkel
       der ikke er en side, så den er også den eneste hvis markering skifter uden
       en navigation. Fjerner man tilbudschippen, skal skiven tilbage til den
       cirkel serveren markerede, og det er ikke altid "Alle": står man på en
       hylde, er det hylden. Derfor huskes serverens valg i stedet for at gætte.

       `data-disc-server` er sat af inline-scriptet PÅ den cirkel Liquid markerede,
       inden det selv flytter markeringen til Tilbud ved ?tilbud=1. Uden den ville
       vi her læse Tilbud som serverens valg, fordi den her fil er deferred og
       kører sidst, og så kunne markeringen aldrig komme tilbage. */
    var discRow = root.querySelector(".plp__discs-row");
    var discServer = discRow &&
      (discRow.querySelector("[data-disc-server]") || discRow.querySelector(".plp__disc-btn.is-active"));
    function markerDisc() {
      if (!discRow) return;
      var maal = st.tilbud ? discRow.querySelector("[data-disc-tilbud]") : discServer;
      if (!maal) return;
      // Findes hooken, ejer den både klassen og den røde skive, og de to kan ikke
      // komme fra hinanden. Findes den ikke — markørscriptet sprang fra, fx fordi
      // ingen cirkel var markeret — skal MARKERINGEN stadig virke.
      if (discRow.saetAktiv) { discRow.saetAktiv(maal); return; }
      var nu = discRow.querySelector(".plp__disc-btn.is-active");
      if (nu === maal) return;
      if (nu) nu.classList.remove("is-active");
      maal.classList.add("is-active");
    }

    function apply(replace) {
      st.page = 1;              // et ændret filter giver et nyt resultatsæt: start forfra
      writeState(st, replace);
      renderAll();
    }

    /* Hvor et sideskift skal lande: hyldecirklerne øverst, filterbaren og varerne
       lige under, heroen ét scroll opad. Samme punkt som serverens pager sigter
       efter med sit fragment (se page_anchor i collection.liquid) — ellers ville
       de to veje føre forskellige steder hen alt efter om der var et filter sat.

       Headerhøjden måles på filterbarens opløste `top`, ikke på :root. Det gamle
       udtryk slog parseInt på --sticky-stack-total, som er en calc() og derfor
       giver NaN, så reglen ramte i praksis ALTID sit hårdkodede 156. */
    function landingY() {
      var mark = root.querySelector("#kategorier, .plp__anchor");
      var pinned = bar ? parseFloat(getComputedStyle(bar).top) || 0 : 0;
      if (mark) return mark.getBoundingClientRect().top + window.pageYOffset - pinned;
      // Søgesiden har hverken cirkler eller mærke. Dér er gitterets første række det
      // øverste der giver mening, og den skal ligge fri af baren.
      return grid.getBoundingClientRect().top + window.pageYOffset
        - pinned - (bar ? bar.getBoundingClientRect().height : 0) - 16;
    }

    /* Et sideskift skal se ud som ÉN ting der sker, ikke som en rejse.
       Målt før: den bløde rulning tog ~900ms hvor man så hele siden fyge forbi med
       varer der allerede var skiftet ud, og serverens pager viste heroen i 640ms
       før browseren sprang ned til fragmentet. Begge dele læses som et ryk.

       Derfor: mål landingspunktet FØR gitteret røres (mærket ligger over gitteret,
       så dets plads i dokumentet er upåvirket af hvad der lægges ind nedenunder),
       spring derned uden animation, og skift så indholdet — alt sammen i samme
       synkrone blok. Browseren når kun at male én gang, og den maling er allerede
       den færdige tilstand. Ingen bevægelse at få øje på.

       Baren låses synlig et øjeblik: springet fyrer en scroll-hændelse med et stort
       udslag, og uden det ville den tolke det som at brugeren ruller videre ned. */
    function goToPage(n) {
      st.page = Math.max(1, n || 1);
      writeState(st);
      var y = Math.max(0, landingY());
      if (window.EndorseShowFilterBar) window.EndorseShowFilterBar(600);
      window.scrollTo(0, y);
      renderGrid();
    }

    /* --- events (delegated: the option lists are re-rendered constantly) --- */
    root.addEventListener("click", function (e) {
      // Sidetal i vores egen pager. Kun renderGrid(), ikke renderAll(): et sideskift
      // ændrer hverken filtrene eller antallene, kun hvilket udsnit der vises.
      var pg = e.target.closest("[data-plp-pager] [data-page]");
      if (pg) {
        e.preventDefault();
        goToPage(parseInt(pg.getAttribute("data-page"), 10));
        return;
      }

      /* Serverens egen pager røres IKKE. Det var fristende at tage klikket her og
         tegne næste side i browseren — så slipper man for en navigation og dermed
         for glitchet. Men målt: vores rækkefølge er ikke Shopifys. Side 2 tegnet
         af os gav 26 helt andre varer end serverens side 2 (Raunsborg mod L'Oréal),
         så en kunde ville se nogle varer to gange og andre aldrig. catalog-facets
         bærer ikke kollektionens egen sortering, og indtil den gør, ejer serveren
         den ufiltrerede paginering. Glitchet er løst et andet sted: heroen foldes
         sammen på side 2+ (se .plp-paged i theme.liquid), så den nye side maler
         korrekt fra første frame i stedet for at skulle springe bagefter. */

      /* TILBUDSCIRKLEN slår filtret til og fra PÅ STEDET. Linket er en rigtig URL
         (?tilbud=1) og virker uden JS, men fulgte vi den, ville serveren sende
         hele kategorien igen og vi ville filtrere den ned bagefter: hele gitteret
         tegnet to gange for et klik der skal opføre sig som et filter. Er man
         allerede på tilbud, slår samme cirkel det fra igen.
         Uden data endnu: lad linket gå til serveren, så virker klikket alligevel. */
      var discT = e.target.closest("[data-disc-tilbud]");
      if (discT && D) {
        e.preventDefault();
        st.tilbud = !st.tilbud;
        apply();
        return;
      }

      var opt = e.target.closest(".plp__fopt[data-val]");
      if (opt) {
        e.preventDefault();
        if (opt.classList.contains("is-disabled")) return;
        var key = opt.closest(".plp__fgroup").getAttribute("data-group");
        var val = opt.getAttribute("data-val");
        if (filterKlik(key, val)) return;
        var arr = key === MAERKE ? st.brands : (st.dims[key] = st.dims[key] || []);
        var at = arr.indexOf(val);
        if (at > -1) arr.splice(at, 1); else arr.push(val);
        apply();
        return;
      }
      var chip = e.target.closest("[data-chip-key]");
      if (chip) {
        e.preventDefault();
        var ck = chip.getAttribute("data-chip-key"), cv = chip.getAttribute("data-chip-val");
        if (filterKlik(ck, cv)) return;
        if (ck === MAERKE) st.brands.splice(st.brands.indexOf(cv), 1);
        else if (ck === LAGER) st.stock = false;
        else if (ck === LIKED) st.liked = false;
        else if (ck === TILBUD) st.tilbud = false;
        else if (ck === PRIS) st.price = null;
        else if (st.dims[ck]) st.dims[ck].splice(st.dims[ck].indexOf(cv), 1);
        apply();
        return;
      }
      if (e.target.closest("[data-chip-clear]")) {
        e.preventDefault();
        // "Ryd alt" paa en typeside rydder ogsaa SIDEN: den staar som en chip, saa den skal med.
        if (typer.length) { location.assign(opUrl || ("/collections/" + cat)); return; }
        st = { dims: {}, brands: [], price: null, stock: false, liked: false, tilbud: false, sort: st.sort, q: st.q };
        apply();
        return;
      }
      // Data-attributter, IKKE .plp__toggle-klassen: der står nu TO toggles i
      // baren, og et klasse-opslag ville gøre favorit-togglen til en ekstra
      // "Kun på lager".
      var tog = e.target.closest("[data-stock-toggle]");
      if (tog) { e.preventDefault(); st.stock = !st.stock; apply(); return; }
      var ltog = e.target.closest("[data-liked-toggle]");
      if (ltog) { e.preventDefault(); st.liked = !st.liked; apply(); return; }
      // Tilbud som toggle i baren — samme tilstand som tilbudscirklen i hylde-
      // rækken (st.tilbud), så de to markeringer kan aldrig komme ud af takt.
      var btog = e.target.closest("[data-tilbud-toggle]");
      if (btog) { e.preventDefault(); st.tilbud = !st.tilbud; apply(); return; }
      var moreT = e.target.closest("[data-more-toggle]");
      if (moreT) {
        e.preventDefault();
        var row = root.querySelector("[data-more-row]");
        if (row) row.hidden = !row.hidden;
        renderAll();
        return;
      }
      var sortOpt = e.target.closest("[data-sort-val]");
      if (sortOpt) {
        e.preventDefault();
        st.sort = sortOpt.getAttribute("data-sort-val");
        var lbl = root.querySelector("[data-sort-label]");
        if (lbl) lbl.textContent = sortOpt.textContent.trim();
        root.querySelectorAll("[data-sort-val]").forEach(function (o) { o.classList.toggle("is-active", o === sortOpt); });
        apply();
      }
    });

    // Price is a form so it can be dragged then applied in one go.
    var priceForm = root.querySelector(".plp__price-range");
    if (priceForm) {
      priceForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var lo = parseInt(priceForm.querySelector("[data-slider-min]").value, 10);
        var hi = parseInt(priceForm.querySelector("[data-slider-max]").value, 10);
        var max = parseInt(priceForm.querySelector("[data-price-slider]").getAttribute("data-max"), 10);
        st.price = (lo <= 0 && hi >= max) ? null : [lo, hi];
        apply();
      });
    }

    window.addEventListener("popstate", function () { st = laesState(); renderAll(); });

    // Et unlike med favorit-filteret aktivt skal fjerne kortet med det samme —
    // theme.js' likes-motor melder hvert toggle her.
    document.addEventListener("endorse:likes-changed", function () {
      if (st.liked && D) renderAll();
    });

    // Kampagne-feedet er async (campaign-live.js). Lander det EFTER en tilbuds-
    // filtrering (fx direkte load af ?tilbud=1), mangler kampagnevarerne i
    // gitteret indtil vi tegner om her. Uden aktivt tilbudsfilter: intet at gøre
    // — priserne kommer fra overlayet, ikke herfra.
    document.addEventListener("endorse:campaigns", function () {
      if (st.tilbud && D) renderAll();
    });

    // Kampagnefelternes pulje er afgjort (eller skiftet): fyld-tilstanden afhænger
    // af om den er tom. Uden facets-data tegner vi ikke selv — serverens side står.
    document.addEventListener("endorse:felter", function (e) {
      if (e.detail && e.detail.grid && e.detail.grid !== grid) return;
      if (D) renderGrid();
    });
    // Skifter kolonneantallet, skifter sidestørrelsen i fyld-tilstanden (30 → 28).
    var fyldCols = colsOf(grid), fyldTimer;
    window.addEventListener("resize", function () {
      clearTimeout(fyldTimer);
      fyldTimer = setTimeout(function () {
        var c2 = colsOf(grid);
        if (c2 === fyldCols) return;
        fyldCols = c2;
        if (D && grid.__campPool) renderGrid();
      }, 200);
    });

    loadFacets().then(function (d) {
      D = d;
      // Drop any query param that isn't a real dimension, so a stray key can never
      // silently filter the whole catalogue away.
      var known = {};
      d.dims.forEach(function (dim) { known[dim.k] = 1; });
      Object.keys(st.dims).forEach(function (k) { if (!known[k]) delete st.dims[k]; });

      // Mærkenavne matches mod facetternes stavemåde uden hensyn til store og små
      // bogstaver, og rettes til den kanoniske. Ellers er ?maerke=AVEDA nul produkter
      // mens ?maerke=Aveda er hele listen, og det er ikke til at gennemskue for den der
      // klikker. Det sker i praksis: søgeindekset bærer stadig de gamle versal-mærker
      // fra før vendor-oprydningen, og gamle links lever videre i folks historik.
      if (st.brands.length && d.brands) {
        var canon = {};
        d.brands.forEach(function (b) { canon[b.toLowerCase()] = b; });
        st.brands = st.brands.map(function (b) { return canon[b.toLowerCase()] || b; });
      }
      base = baseSet();
      root.setAttribute("data-plp-ready", "1");
      renderAll();
      root.dispatchEvent(new CustomEvent("endorse:facets-ready"));
    }).catch(function () {
      // Data unavailable: the server-rendered page stays exactly as it is.
      root.setAttribute("data-plp-failed", "1");
    });

    // The search page hands us its own result set once the search engine has run. It can
    // arrive before or after the facets load, so both paths have to cope.
    var pendingHandles = null;
    root.addEventListener("endorse:results", function (e) {
      ownResults = true;
      root.setAttribute("data-plp-handles", (e.detail.handles || []).join(","));
      if (!D) { pendingHandles = true; return; }
      base = baseSet();
      renderAll();
    });
    root.addEventListener("endorse:facets-ready", function () {
      if (pendingHandles) { base = baseSet(); renderAll(); }
    });
  }

  function boot() {
    document.querySelectorAll("[data-plp]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
